import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const GearFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function GearFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="m20.61 11.035 1.84-3.19-1.63-2.82H17.3l-2.45-1.41-1.51-2.61h-2.69l-1.61 2.79-2.14 1.23H3.21l-1.42 2.62 1.53 2.65.07 2.67-1.84 3.19 1.63 2.82H6.7l2.45 1.41 1.51 2.61h2.69l1.61-2.79 2.14-1.23h3.69l1.42-2.62-1.53-2.65-.07-2.67ZM12 15.505c-1.94 0-3.5-1.56-3.5-3.5s1.56-3.5 3.5-3.5 3.5 1.56 3.5 3.5-1.56 3.5-3.5 3.5Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default GearFilled;